(function IIFE() {
    'use strict';

    /////////////////////////////

    function UserFollowerService(LumsitesBaseService, UserFollowerFactory) {
        'ngInject';

        return LumsitesBaseService.createLumsitesBaseService(UserFollowerFactory, {
            autoInit: false,
            objectIdentifier: 'uid',
        });
    }

    /////////////////////////////

    angular.module('Services').service('UserFollower', UserFollowerService);
})();
